module.exports = __webpack_public_path__ + "static/img/bodyImg2.997f57fc.png";